export const MAIN_FONT = 'Source Sans Pro';
export const ALT_FONT = 'Poppins';
